export const CUSTOM_GROUPS_QUERY_KEY = 'custom-product-groups';
export const CREATE_NEW_GROUP_VALUE = '__create_new__';
